import axios from 'axios';

const BUNNY_STORAGE_ZONE = "sigal"; // Your Bunny Storage Zone
const BUNNY_API_KEY = "f2b08c64-db6b-442d-9e5a2bce9766-f4df-4c3f"; // Your Bunny Storage API Key
const BUNNY_STORAGE_HOST = `https://storage.bunnycdn.com/${BUNNY_STORAGE_ZONE}/`;
const BUNNY_CDN_URL = `https://${BUNNY_STORAGE_ZONE}.b-cdn.net/`; // Public URL for access
const STORAGE_FOLDER = "airtable_uploads"; // Folder inside Bunny Storage

/**
 * Uploads a Base64 image to BunnyNet Storage.
 */

const uploadBunny = async (base64, fileName) => {
    try {
        // Ensure we have valid base64 data
        if (!base64) {
            throw new Error('No base64 data provided');
        }

        // Create binary data from base64
        const binaryData = atob(base64);
        const len = binaryData.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryData.charCodeAt(i);
        }

        // Create blob with proper PDF type
        const blob = new Blob([bytes], { type: 'application/pdf' });
        
        const filePath = `${STORAGE_FOLDER}/${fileName}`;
        const uploadUrl = `${BUNNY_STORAGE_HOST}${filePath}`;

        // Upload with proper content length and type
        const response = await axios.put(uploadUrl, blob, {
            headers: {
                'AccessKey': BUNNY_API_KEY,
                'Content-Type': 'application/pdf',
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity
        });

        if (response.status === 201) {
            console.log('✅ File uploaded to BunnyNet Storage:', filePath);
            console.log('📦 File size:', (blob.size / 1024).toFixed(2), 'KB');
            return `${BUNNY_CDN_URL}${filePath}`;
        } else {
            throw new Error(`Upload failed with status: ${response.status}`);
        }
    } catch (error) {
        console.error('❌ Error uploading to BunnyNet Storage:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error; // Re-throw to handle in the calling function
    }
};

export { uploadBunny };